<input type="text" (blur)="onInputBlur($event)" [formControl]="textControl" />
